import NormalTable, { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./dataset-details.scss";
import Spinner from "../../../shared/components/spinner/spinner";
import { roleWrite,roleRead,roleAdmin } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, deleteMultiple, IListPageData } from "../../../shared/utils/api";

import { useContext, useEffect, useState, Fragment } from "react";

import { useBack } from "../../../shared/utils/use-back";

import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { FaPencilAlt } from "react-icons/fa";

import { validateLoadingStatusNew } from "../../../shared/utils/utils";

const columns: IColumn[] = [
  {
    key: "modelversion_name",
    displayName: "Model Name",
    dataType: {
      type: "text",
    },
  }
];

const DatasetDetails = () => {
  const [unblockInput, setUnblockInput] = useState(false);
  const [data, setData] = useState<IListPageData | undefined>(undefined);
  const [sortedBy, setSortedBy] = useState("?order_by=modelversion_name asc");
  const [lastTriggeredModal, setLastTriggeredModal] = useState<string | undefined>(undefined);

  const authCtx = useContext(AuthContext);
  const [runningModel, setRunningModel] = useState({modelconfig_id: null});
  const { sendRequest: getModelStatus, status: getModelStatusStatus, data: getModelStatusData, error: getModelStatusError } = useHttp(getAllData, false, authCtx.token, "modelStatus", "analytics");
  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, true, authCtx.token, undefined, "analytics");
  const { sendRequest: getTrigger, status: triggerStatus, error: errorTrigger} = useHttp(getAllData, false, authCtx.token, "trigger", "analytics");
  const { sendRequest: getSingleDataRequest, status: singleStatus, data: singleLoadedData } = useHttp(getAllData, false, authCtx.token, "dataset", "analytics");
  const { sendRequest: deleteMultipleRequest, status: allStatusDelete, data: loadedDataDelete, error: errorDelete } = useHttp(deleteMultiple, false, authCtx.token, undefined, "analytics");

  const params = useParams();
  const { handleBack } = useBack();
  const navigate = useNavigate();
  const rolesArray = authCtx.selectedTenant.roles;

  useEffect(() => {
    getModelStatus("modelrunstatus");
    getSingleDataRequest(`dataset/${params.id}`);
    authCtx.setOnboardingAnalyticsToggleHandler();
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleRead) !== -1 ) {
      getSortBy(`dataset/${params.id}/modelconfigs`, "?order_by=modelversion_name asc");
    }
  }, []);

  useEffect(() => {
    if (rolesArray.indexOf(roleWrite) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    if (getModelStatusStatus === "completed" && !getModelStatusError) {
      setRunningModel(getModelStatusData);
    }
  }, [getModelStatusStatus]);

  useEffect(() => {
    if (triggerStatus === "completed" && !errorTrigger) {
      getModelStatus("modelrunstatus");
    }
  }, [triggerStatus]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    if (allStatusDelete === "completed" && !errorDelete) {
      setData(loadedDataDelete);
      authCtx.setOnboardingAnalyticsToggleHandler();
    }
  }, [allStatusDelete]);

  const handleOnDelete = (ids: string[]) => {
    deleteMultipleRequest(`modelconfigs${sortedBy}`, { ids });
  };

  const triggerTheModel = (id: string) => {
    getTrigger(`trigger/${id}`);
    setLastTriggeredModal(id);
  };

  const editHandler = () => {
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleRead) !== -1 || rolesArray.indexOf(roleAdmin) !== -1) {
      navigate(`/analytics/datasets-edit/${params.id}`);
    }
  };

  const renderExtraColumns = (id: string) => {
    return (
      <Fragment>
        {authCtx.selectedTenant.roles.indexOf(roleRead) !== -1 || authCtx.selectedTenant.roles.indexOf(roleWrite) !== -1? <td>
          <span>
            <span id={"nonClick"} onClick={() => navigate(`/analytics/modelconfig/${id}/reports`)} className="normalTable-rowButton">view reports</span>
          </span>
        </td> : ""}
        <td>
          <span>
            <span onClick={() => (unblockInput && !runningModel.modelconfig_id) && triggerTheModel(id)} id={"nonClick"} className={`normalTable-rowButton${runningModel.modelconfig_id? "-disabled" : ""}`}>generate the model</span>
          </span>
        </td>

        {(triggerStatus === "completed" && !errorTrigger && lastTriggeredModal === id) || (runningModel.modelconfig_id === id) ? <td><span>in progress</span></td> : <td><span></span></td> }
      </Fragment>
    );
  };

  const sortBy = (sortingQuery: string) => {
    getSortBy(`dataset/${params.id}/modelconfigs`, `${sortingQuery}`);
    setSortedBy(sortingQuery);
  };

  const findRunningModelData = () => {
    if (data && runningModel.modelconfig_id) {
      return data.rows.find(row => runningModel.modelconfig_id === row.id)?.modelversion_name || "";
    }
    return "";
  };

  const renderPathButtons = () => {
    return (
      <span>
        <span onClick={() => navigate("/analytics/datasets")} className="optionPath">Datasets</span>
        <span className="optionPathDelimiter">-</span>
        <span className="selectedPathBtn">Dataset</span>
      </span>
    );
  };

  return (
    <div className="datasetDetails">
      {validateLoadingStatusNew([singleStatus, getSortByStatus, triggerStatus]) && <Spinner />}
      
      <div onClick={() => handleBack()} className="datasetDetails-nav-btn">
        <BsArrowLeft />
      </div>

      <div className="datasetDetails-header">
        <h1>{singleLoadedData && singleLoadedData.dataset_name}<FaPencilAlt onClick={editHandler} className="datasetDetails-edit"/></h1>
        {renderPathButtons()}
      </div>

      {runningModel.modelconfig_id && <div className="datasetDetails-banner" onClick={() => navigate("/analytics/run-status")}>
        {`${!findRunningModelData() ? "Another" : "The"} ${findRunningModelData()} model has been triggered successfully. Click here to check the status.`}
      </div>}

      {data && data.rows.length === 0 &&
        <div className="datasetDetails-noData">
          No model configurations found for this dataset. Click on plus button to create a new model configuration.
        </div> 
      }
      <NormalTable
        handleOnDelete={handleOnDelete}
        columns={columns}
        sortBy={sortBy}
        defaultSortCol={"modelversion_name"}
        fetchedData={data && data}
        unblockInput={unblockInput}
        allStatus={getSortByStatus}
        dataUrl={"datasets/:id"}
        hideButtons={[]}
        renderExtraColumns={renderExtraColumns}
      />

      
    </div>
  );
};

export default DatasetDetails;